import React from "react";
import locale from "locales";
import * as style from "./style.mod.scss";
const StickyCartButton = ({ buttonRef, TotalSumPriceProps, handleAddToCart, ctaDisabled, isAvailableForSaleProps, productTitle, variantSubtitle, previewImageUrl }) => {


  return (
    <div className={style.cartButton} ref={buttonRef}>
      <div className={style.textPrice}>
        <div className={style.sumContainer}>
          <div className={style.stickyInfo}>
            <img
              src={previewImageUrl}
              alt={productTitle || "Product image"}
              className={style.badgeImg}
              loading="lazy"
            />
            <div className={style.stickyInfoContainer}>
              <h3>{productTitle}</h3>
              {variantSubtitle && <p>{variantSubtitle}</p>}
              <div className={`${style.sumPrices} ${style.overrideProductPrice}`}>
                <TotalSumPriceProps />
              </div>
            </div>
          </div>
        </div>
        <div>
          {
            <button className={style.cartBtn} onClick={handleAddToCart} disabled={ctaDisabled}>{isAvailableForSaleProps ? <p className={style.addToCart}>{locale.products.otherButton}</p> : locale.products.soldOut}</button>}
        </div>
      </div>
    </div>
  );
};

export default StickyCartButton;